// extracted by mini-css-extract-plugin
module.exports = {"topSection":"IndividualSidebar_topSection__3CJMy","headerItem":"IndividualSidebar_headerItem__1nA2i","contentSection":"IndividualSidebar_contentSection__28Zfl"};